
const plmModulo = {
    agGrid: {
        pagination  : true,
        pagina      : 15,
        id          : 'myGrid',
        //class       : 'ag-theme-alpine',
        class       : 'ag-theme-balham',
        rowHeight   : 35,
        style: {
            width: '100%',
            height: '700px',
            'font-size': 'smaller',
        }
    },
    agGridModal: {
        paginacion: 10,
        id: 'myGrid',
        class: 'ag-theme-material mt-3',
        style: {
            width: '100%',
            height: '450px'
        }
    },
    titulos: {
        global: {
          modulo          : 'PLM-QA',
          tituloAgregar   : 'Agregar Nuevo Registro',
          tituloActualizar: 'Actualizar Registro',
          tituloEliminar  : 'Eliminar Registro',
        },
        documentos: {
          carga        : 'Carga de Matriz QM',
          tituloCardList  : 'Clases de inpección Ampliado',
        }
    },
    url: {
        crudClaseInspeccion : 'clase-inspeccion/',
        matrizPreCargarCSV  : 'clase-inspeccion/preupload/csv',   
        matrizGuardarCSV    : 'clase-inspeccion/upload/csv', 
        logMatrizQm         : 'log-matriz-qm/', 
    },
    button: {
        buttonsCss: {
            primary   : 'btn btn-primary btn-block',
            secondary : 'btn btn-secondary btn-block',
            success   : 'btn btn-success btn-block',
            danger    : 'btn btn-danger btn-block',
            warning   : 'btn btn-warning btn-block',
            info      : 'btn btn-info btn-block',
            light     : 'btn btn-light btn-block',
            dark      : 'btn btn-dark btn-block',
            primaryOutline   : 'btn btn-outline-primary',
            secondaryOutline : 'btn btn-outline-secondary',
            successOutline   : 'btn btn-outline-success',
            dangerOutline    : 'btn btn-outline-danger',
            warningOutline   : 'btn btn-outline-warning',
            infoOutline     : 'btn btn-outline-info',
            lightOutline    : 'btn btn-outline-light',
            darkOutline     : 'btn btn-outline-dark',
            primarylg     : 'btn btn-primary btn-lg btn-block',
            successLg     : 'btn btn-success btn-lg btn-block',
            dangerLg      : 'btn btn-danger btn-lg btn-block',
            warningLg     : 'btn btn-warning btn-lg btn-block',
            warningLgFile : 'btn btn-warning btn-lg btn-block btn-file',
        },
        buttonsNombre: {
            editar      : 'Editar',
            ver         : 'Ver',
            eliminar    : 'Eliminar',
            agregar     : 'Agregar ',
            guardar     : 'Guardar',
            actualizar  : 'Actualizar',
            mostrar     : 'Mostrar seleccion',
            regresar    : 'Regresar',
            continuar     : 'Continuar',
            seleccionar   : 'Seleccionar',
            procesar      : 'Procesar',
            buscar        : 'Buscar',
            sustento      : 'Sustento',
            validar       : 'Validar',
            descargar       : 'Descargar',
            descargarRecibo: 'Descargar Recibo Cobros',
            descargarEstado: 'Descargar Estados Docs',
            detalle       : 'Ver Ordenes',
            agregarProducto: 'AÃ±adir Productos',
            anadirProducto: 'AÃ±adir',
            limpiar     : 'Eliminar todos los productos',
            anular      : 'Anular',
            aprobar     : 'Aprobar',
        }
    },
    mensajes: {
        errorServicio   : 'error..!!',
        desabilitada    : 'Opción desabilitada',
        eliminar        : '¿Está seguro de que desea eliminar el siguiente elemento?',
        guardar         : '¿Está seguro de que desea guardar?',
        actualizar      : '¿Está seguro de que desea actualizar elemento?',
        datoGuardado    : 'Se guardo corectamente..!!',
        guardarParada   : 'Esta seguro que desea registrar este evento..??',
        procesar        : '¿Esta seguro que desea procesar el siguiente elemento?',
        validar         : '¿Esta seguro que desea validar el siguiente elemento?',
        anticipo        : 'Se tomara este valor como anticipo.',
        camposObligatorio: 'Los campos tipo transaccion y nÃºmero documento deben estar llenos caso contrario se tomara como anticipo.',
        anular          : 'Confirma que desea eliminar el registro seleccionado.',
        garitaAprobar   : '¿Esta seguro que desea Aprobar la revisión del viaje?',
        garitaFinalizar : '¿Esta seguro que desea Finalizar el viaje?'
    }
}

export type PlmDiccionario = typeof plmModulo;
export { plmModulo }